import React from 'react';
import { Building, LinkedinSquare, Search, World } from '@saleshandy/icons';
import { BulkFiltersConfig } from '../type';

// Use key value same as defined in useLeadFilter.tsx
export const BULK_SEARCH_FILTERS: BulkFiltersConfig = [
  {
    key: 'company_name',
    icon: <Building height={16} width={16} />,
    labelText: 'Company Name',
    showExactMatchCheckbox: false,
    maxInputCount: 100,
    placeholder:
      'Enter list of Company Name separated by commas, semicolon or line breaks.',
  },
  {
    key: 'company_domain',
    icon: <World />,
    labelText: 'Company Domain',
    placeholder: 'Enter Company Domain',
    showExactMatchCheckbox: false,
    maxInputCount: 100,
  },
  {
    key: 'linkedin_url',
    icon: <LinkedinSquare height={16} width={16} />,
    labelText: 'LinkedIn URL',
    maxInputCount: 2000,
    placeholder:
      'Enter LinkedIn URL (e.g. https://www.linkedin.com/in/john-doe) separated by commas, semicolon or line breaks.',
  },
  // {
  //   key: 'company_industry',
  //   icon: <BuildingArch height={16} width={16} />,
  //   labelText: 'Industry',
  //   maxInputCount: 100,
  //   placeholder:
  //     'Enter Industry (e.g. IT & Software) separated by commas, semicolon or line breaks.',
  // },
  // {
  //   key: 'job_title',
  //   icon: <Briefcase height={16} width={16} />,
  //   labelText: 'Job Title',
  //   showExactMatchCheckbox: true,
  //   maxInputCount: 100,
  //   placeholder:
  //     'Enter Job Title (e.g. CEO, Sales Head) separated by commas, semicolon or line breaks.',
  // },
  // {
  //   key: 'skills',
  //   icon: <Tool height={16} width={16} />,
  //   labelText: 'Skills',
  //   showExactMatchCheckbox: true,
  //   maxInputCount: 100,
  //   placeholder:
  //     'Enter Skills (e.g. Lead Generation) separated by commas, semicolon or line breaks.',
  // },
  {
    key: 'keywords',
    icon: <Search height={16} width={16} />,
    labelText: 'Keywords',
    maxInputCount: 100,
    placeholder:
      'Enter Keywords separated by commas, semicolon or line breaks.',
  },
];
